export const style = (theme) => ({
  ".loader": {
    // Background is now handled inline with gradient
    // Keeping this for any additional global styles if needed
  },
});
